import './blog-filter.scss';

let documentBindingsInitialized = false;
let activeRequestController = null;

function panelStorageKey( form ) {
	const id = form && form.id ? form.id : 'default';
	return 'blogFilter:panelOpen:' + id + ':' + window.location.pathname;
}

function setOpenState( root, open ) {
	const toggle = root.querySelector( '[data-blog-filter-toggle]' );
	const panel  = root.querySelector( '[data-blog-filter-panel]' );

	if ( ! toggle || ! panel ) {
		return;
	}

	root.classList.toggle( '-open', open );
	toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );

	if ( open ) {
		panel.removeAttribute( 'hidden' );
	} else {
		panel.setAttribute( 'hidden', '' );
	}

	try {
		sessionStorage.setItem( panelStorageKey( root ), open ? '1' : '0' );
	} catch ( e ) {
		// Private mode or quota: ignore.
	}
}

function bindDocumentEvents() {
	if ( documentBindingsInitialized ) {
		return;
	}

	documentBindingsInitialized = true;

	document.addEventListener( 'pointerdown', ( event ) => {
		const openRoots = document.querySelectorAll( '[data-component="blog-filter"].-open' );

		openRoots.forEach( ( root ) => {
			if ( root.contains( event.target ) ) {
				return;
			}

			setOpenState( root, false );
		} );
	}, true );

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key !== 'Escape' ) {
			return;
		}

		const openRoot = document.querySelector( '[data-component="blog-filter"].-open' );

		if ( ! openRoot ) {
			return;
		}

		setOpenState( openRoot, false );

		const toggle = openRoot.querySelector( '[data-blog-filter-toggle]' );
		if ( toggle ) {
			toggle.focus();
		}
	} );
}

function countActiveFilters( form ) {
	let active = 0;
	const fields = form.querySelectorAll( '[data-blog-filter-field]' );

	fields.forEach( ( field ) => {
		const type = ( field.type || '' ).toLowerCase();

		if ( type === 'checkbox' || type === 'radio' ) {
			if ( field.checked ) {
				active++;
			}

			return;
		}

		if ( field.value && field.value.trim() !== '' ) {
			active++;
		}
	} );

	return active;
}

function updateCount( form ) {
	const count  = form.querySelector( '[data-blog-filter-count]' );
	const reset  = form.querySelector( '[data-blog-filter-reset]' );
	const active = countActiveFilters( form );

	if ( count ) {
		count.textContent = '(' + active + ')';
	}

	if ( ! reset ) {
		return;
	}

	if ( active > 0 ) {
		reset.removeAttribute( 'hidden' );
	} else {
		reset.setAttribute( 'hidden', '' );
	}
}

function getAjaxConfig() {
	if ( typeof window.BlogArchive !== 'object' || window.BlogArchive === null ) {
		return null;
	}

	if ( ! window.BlogArchive.ajaxUrl || ! window.BlogArchive.nonce ) {
		return null;
	}

	return window.BlogArchive;
}

function buildFilterParams( form ) {
	const formData = new FormData( form );
	const params   = new URLSearchParams();

	formData.forEach( ( value, key ) => {
		if ( typeof value !== 'string' || value.trim() === '' ) {
			return;
		}

		params.append( key, value );
	} );

	return params;
}

function updateBrowserUrl( form ) {
	const params = buildFilterParams( form );
	params.delete( 'blog_pagina' );
	const query = params.toString();
	const url   = query ? form.action + '?' + query : form.action;

	window.history.pushState( {}, '', url );
}

function setLoadingState( form, loading ) {
	const results = document.querySelector( '[data-blog-archive-results]' );

	form.classList.toggle( '-loading', loading );

	if ( results ) {
		results.setAttribute( 'aria-busy', loading ? 'true' : 'false' );
		results.classList.toggle( '-loading', loading );
	}
}

function submitAjax( form ) {
	const ajaxConfig = getAjaxConfig();
	const results    = document.querySelector( '[data-blog-archive-results]' );

	if ( ! ajaxConfig || ! results || typeof window.fetch !== 'function' ) {
		return false;
	}

	const body = buildFilterParams( form );
	body.append( 'action', 'filter_blog_archive' );
	body.append( 'nonce', ajaxConfig.nonce );

	if ( activeRequestController ) {
		activeRequestController.abort();
	}

	const requestController = new AbortController();
	activeRequestController = requestController;

	setLoadingState( form, true );

	window.fetch(
		ajaxConfig.ajaxUrl,
		{
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			},
			signal: requestController.signal,
			body: body.toString(),
		}
	)
		.then( ( response ) => {
			if ( ! response.ok ) {
				throw new Error( 'Blog archive filter request failed.' );
			}

			return response.json();
		} )
		.then( ( payload ) => {
			if ( ! payload || ! payload.success || ! payload.data || typeof payload.data.html !== 'string' ) {
				throw new Error( 'Blog archive filter response was invalid.' );
			}

			results.innerHTML = payload.data.html;
			updateBrowserUrl( form );
		} )
		.catch( ( error ) => {
			if ( error.name === 'AbortError' ) {
				return;
			}

			form.submit();
		} )
		.finally( () => {
			if ( activeRequestController !== requestController ) {
				return;
			}

			activeRequestController = null;
			setLoadingState( form, false );
		} );

	return true;
}

function submitForm( form ) {
	if ( submitAjax( form ) ) {
		return;
	}

	if ( typeof form.requestSubmit === 'function' ) {
		form.requestSubmit();
		return;
	}

	form.submit();
}

function initBlogFilter() {
	const roots = document.querySelectorAll( '[data-component="blog-filter"]' );

	if ( ! roots.length ) {
		return;
	}

	bindDocumentEvents();

	roots.forEach( ( root ) => {
		if ( root.dataset.blogFilterInitialized === 'true' ) {
			return;
		}

		const form   = root;
		const toggle = root.querySelector( '[data-blog-filter-toggle]' );
		const reset  = root.querySelector( '[data-blog-filter-reset]' );
		const fields = root.querySelectorAll( '[data-blog-filter-field]' );

		if ( ! toggle ) {
			return;
		}

		root.dataset.blogFilterInitialized = 'true';

		toggle.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			setOpenState( root, ! root.classList.contains( '-open' ) );
		} );

		if ( reset ) {
			reset.addEventListener( 'click', ( event ) => {
				event.preventDefault();

				fields.forEach( ( field ) => {
					if ( field.type === 'checkbox' || field.type === 'radio' ) {
						field.checked = false;
					}
				} );

				updateCount( form );
				submitForm( form );
			} );
		}

		form.addEventListener( 'submit', ( event ) => {
			if ( ! submitAjax( form ) ) {
				return;
			}

			event.preventDefault();
		} );

		fields.forEach( ( field ) => {
			field.addEventListener( 'change', () => {
				updateCount( form );
				submitForm( form );
			} );
		} );

		let storedOpen = false;

		try {
			storedOpen = sessionStorage.getItem( panelStorageKey( form ) ) === '1';
		} catch ( e ) {
			storedOpen = false;
		}

		setOpenState( root, storedOpen );
		updateCount( form );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initBlogFilter );
} else {
	initBlogFilter();
}
